const THEME_STORAGE_KEY = 'restaurant-manager::theme-preference';

const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';

export const getSystemTheme = () => {
  if (!isBrowser() || typeof window.matchMedia !== 'function') {
    return 'light';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const getStoredThemePreference = () => {
  if (!isBrowser()) {
    return 'system';
  }
  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'system') {
    return stored;
  }
  return 'system';
};

export const setStoredThemePreference = (preference) => {
  if (!isBrowser()) {
    return;
  }
  const normalized =
    preference === 'light' || preference === 'dark' || preference === 'system'
      ? preference
      : 'system';
  window.localStorage.setItem(THEME_STORAGE_KEY, normalized);
};

export const applyThemePreference = (preference) => {
  if (!isBrowser()) {
    return 'light';
  }

  const resolvedTheme =
    preference === 'dark' || (preference === 'system' && getSystemTheme() === 'dark')
      ? 'dark'
      : 'light';

  const { documentElement } = document;
  if (resolvedTheme === 'dark') {
    documentElement.classList.add('dark');
  } else {
    documentElement.classList.remove('dark');
  }
  documentElement.dataset.theme = resolvedTheme;

  return resolvedTheme;
};

export const subscribeToSystemTheme = (listener) => {
  if (!isBrowser() || typeof window.matchMedia !== 'function') {
    return () => {};
  }

  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  const handler = (event) => {
    listener(event.matches ? 'dark' : 'light');
  };

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }

  mediaQuery.addListener(handler);
  return () => mediaQuery.removeListener(handler);
};

export const initializeThemePreference = () => {
  const preference = getStoredThemePreference();
  const resolved = applyThemePreference(preference);
  return { preference, resolved };
};

export default {
  getSystemTheme,
  getStoredThemePreference,
  setStoredThemePreference,
  applyThemePreference,
  subscribeToSystemTheme,
  initializeThemePreference,
};
